import { memo } from 'react'

import { CatalogItem } from '@/entities/catalog/types'

import { SquareCatItem } from './SquareCatItem'

import styles from './SquareCatBlock.module.scss'

export type SquareCatBlockProps = {
	items: CatalogItem[]
	title?: string
	withBaseUrl?: boolean
}

export const SquareCatBlock = memo(
	({ items, title, withBaseUrl = true }: SquareCatBlockProps): JSX.Element => (
		<div className={styles.squareCatBlock}>
			{title && <h2 className={styles.title}>{title}</h2>}
			<ul className={styles.list}>
				{items.map(item => (
					<SquareCatItem {...item} key={item.ID} withBaseUrl={withBaseUrl} />
				))}
			</ul>
		</div>
	)
)
